import { defineMessages } from "react-intl";

const messages = defineMessages({
  addConfirmationCancel: {
    id: "map.toolbar.groups.modal.addConfirmation.cancel",
    defaultMessage: "Wait",
    description: "Add group button confirmation - Wait",
  },
  addConfirmationGroup: {
    id: "map.toolbar.groups.modal.addConfirmation.group",
    defaultMessage:
      "Please note, you will exit the currently selected Group by creating a new one.",
    description: "Add group button confirmation - new group",
  },
  addConfirmationOk: {
    id: "map.toolbar.groups.modal.addConfirmation.ok",
    defaultMessage: "Got it",
    description: "Add group button confirmation - Got It",
  },
  addConfirmationTerritory: {
    id: "map.toolbar.groups.modal.addConfirmation.territory",
    defaultMessage: "Please note, you will exit Territory View by creating a new group.",
    description: "Add group button confirmation - new territory",
  },
  addGroup: {
    id: "map.toolbar.groups.modal.add",
    defaultMessage: "Add",
    description: "Add group button in  groups popover on the Map page",
  },
  delete: {
    id: "map.toolbar.groups.modal.delete",
    defaultMessage: "Delete",
    description: "Delete button",
  },
  deleteGroupButton: {
    id: "map.toolbar.groups.modal.deleteGroups.confirm",
    defaultMessage: "Delete {count, plural, one {Group} other {Groups ({count})}}",
    description: "Delete groups confirmation popover confirm button",
  },
  deleteGroupsTitle: {
    id: "map.toolbar.groups.modal.deleteGroups.title",
    defaultMessage:
      "Are you sure you want to permanently delete {count, plural, one {this group} other {these groups}}?",
    description: "Delete groups confirmation popover title",
  },
  errorDescription: {
    id: "map.toolbar.groups.update.error.modal.description",
    defaultMessage:
      "We’ve run into some issues deleting the following {count, plural, one {group} other {groups}}. Please fix the issues below and then attempt deletion for selected {count, plural, one {group} other {groups}} again.",
    description: "Groups bulk update error modal description",
  },
  errorTitle: {
    id: "map.toolbar.groups.update.error.modal.info.title",
    defaultMessage:
      "{count, plural, one {Selected group was} other {All selected groups were}} not deleted",
    description: "Groups bulk update error modal internal info title",
  },
  manageFrequency: {
    id: "map.toolbar.groups.modal.manageFrequency",
    defaultMessage: "Manage {count, plural, one {Frequency} other {Frequencies ({count})}}",
    description: "Manege frequency title",
  },
  modalTitle: {
    id: "map.toolbar.groups.update.error.modal.title",
    defaultMessage: "Unable to delete {count, plural, one {group} other {groups}}",
    description: "Groups bulk update error modal title",
  },
  okText: {
    id: "map.toolbar.groups.update.error.modal.okay",
    defaultMessage: "Okay",
    description: "Groups bulk update error modal okay button",
  },
  placeholder: {
    id: "map.toolbar.groups.modal.search.placeholder",
    defaultMessage: "Search Groups",
    description: "Search field in groups popover on the Map page",
  },
  setFrequency: {
    id: "map.toolbar.groups.modal.setFrequency",
    defaultMessage: "Set Frequency",
    description: "Set Frequency button",
  },
  share: {
    id: "map.toolbar.groups.modal.share",
    defaultMessage: "Share",
    description: "Share button",
  },
  title: {
    id: "map.toolbar.groups.modal.title.count",
    defaultMessage:
      "{count}/{total} {total, plural, one {{entityType, select, accounts {company group} contacts {people group} deals {deal group} other {group}}} other {{entityType, select, accounts {company groups} contacts {people groups} deals {deal groups} other {groups}}}}",
  },
});

export default messages;
